import Phaser from 'phaser';
import type { Player } from './Player';

export class CopOnFoot {
  readonly sprite: Phaser.Physics.Arcade.Sprite;
  hp = 60;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    const s = scene.physics.add.sprite(x, y, 'cop');
    s.setScale(0.5);
    s.body!.setSize(18, 18);
    s.body!.setOffset((s.width - 18) / 2, (s.height - 18) / 2);
    s.setCollideWorldBounds(true);
    s.setData('cop', this);
    this.sprite = s;
  }

  damage(n: number) {
    this.hp -= n;
    this.sprite.setTintFill(0xff8888);
    this.sprite.scene.time.delayedCall(80, () => this.sprite.clearTint());
    if (this.hp <= 0) this.sprite.destroy();
  }

  update(player: Player) {
    if (!this.sprite.active) return;
    const p = player.pos();
    const dx = p.x - this.sprite.x;
    const dy = p.y - this.sprite.y;
    const len = Math.hypot(dx, dy) || 1;
    const sp = 100;
    this.sprite.setVelocity((dx / len) * sp, (dy / len) * sp);
    this.sprite.rotation = Math.atan2(dx, -dy);
  }

  get alive() { return this.hp > 0 && this.sprite.active; }
}
